import { Heading, BodyLong, VerticalSpace } from '@elhub/ds-components'

import React from 'react'

interface EntityIntroProps {
  entity: string
  title: string
}

const EntityIntro: React.FC<EntityIntroProps> = ({ entity, title }) => {
  return (
    <>
      <Heading>{title}</Heading>
      <BodyLong size='small'>{getDescription(entity)}</BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        You can also retrieve aggregated data by specifying the dataset in the query param. Please
        refer to the below "Available Datasets" table to view the valid datasets for {entity}.
      </BodyLong>
      <VerticalSpace size='3' />
    </>
  )
}

const getDescription = (entity: string): string => {
  if (entity === 'metering-points') {
    return 'This endpoint allows you to query metering values for a metering point.'
  }
  return `This endpoint allows you to query aggregated consumption / production datasets for per ${entity}.`
}

export default EntityIntro
